import React from 'react';
import PropTypes from 'prop-types';
import { Logo, LogoWithText } from '../../../Logos';
import { TabletScreen, MobileScreen } from '../../../MediaComponents';

import './header-logo.scss';

const HeaderLogo = ({ variant, color, isUserAuthenticated }) => {
  const auth = isUserAuthenticated ? 'auth' : 'anon';

  return (
    <a
      href="/"
      alt="SurveyMonkey Logo"
      className={`sm-header-logo__${auth}--${variant} sm-header-logo__link`}
    >
      {!isUserAuthenticated ? (
        <>
          <TabletScreen>
            <LogoWithText className="sm-header-logo__text" color={color} />
          </TabletScreen>
          <MobileScreen>
            <Logo color={color} className="sm-header-logo__anon-icon" />
          </MobileScreen>
        </>
      ) : (
        <Logo className="sm-header-logo__auth-icon" color="alt" />
      )}
    </a>
  );
};

HeaderLogo.propTypes = {
  isUserAuthenticated: PropTypes.bool,
  color: PropTypes.oneOf(['primary', 'alt']),
  variant: PropTypes.oneOf(['default', 'limited', 'slim']),
};

HeaderLogo.defaultProps = {
  isUserAuthenticated: false,
  color: 'primary',
  variant: 'default',
};

export default HeaderLogo;
